import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';

export const TOUR_PLANNER_TASK_QUERY = gql`
query GetTasksForPlanningQuery(
  $sortProperty: String,
  $sortDirection: String,
  $locationIds: [UUID],
  $depotIds: [UUID],
  $text: String, $preview: Int
  $fromDateTime: String,
  $toDateTime: String,
  $taskAssignmentInput: TaskAssignmentInput,
  $pageNumber: Int, $pageSize: Int,
  $types: [String],
  $commandInputs: [CommandInput]
)
{
  tasksForPlanning: getTasksPaged(
    taskFilter: {
      locationIds: $locationIds,
      depotIds: $depotIds,
      states : [NEW, UNASSIGNED],
      text: $text,
      fromDateTime: $fromDateTime,
      toDateTime: $toDateTime,
      handlingType: DELIVERY,
      preview: $preview,
      types: $types,
      sortRequest: { 
        sortProperties: [$sortProperty],
        sortDirection: $sortDirection
      },
      pagination: {
        number: $pageNumber,
        size: $pageSize,
        sortProperty: $sortProperty,
        sortDirection: $sortDirection
      },
    }
  ){
    totalPages
    totalElements
    number
    size
    content{
      ... taskExcerpt
    }
  }
}

fragment taskExcerpt on Task{
  id
  type
  number
  taskType {
    code
    name
    prefix
    icon
    color
  }
  dueDateTimePeriod {
    modifier
    dateTime
    fromDateTime
    toDateTime
    precision
  }
  fileCount
  commentCount
  noteCount
  commands(commandInputs: $commandInputs)
  state
  description
  title
  color
  order{
    id
    number
    type
    note
    customer {
      type
      companyName
      companyNameExtension
      firstName
      lastName
    }
    location {
      id
      name
      label
    }
    comments {
      text
    }
    fileCount
    commentCount
  }
  address {
    id
    country
    city
    postalCode
    street
    houseNumber
    name
    lat
    lng
    text
    type
    note
    geocodingResultGrade
    ref
  }
  isAssignable(taskAssignmentInput: $taskAssignmentInput)
  linkedContacts: linkedEntities(entityType: "Contact") {
    linkId
    linkType
    linkLabel
    perspective
    role
    linkedEntity {
      ... on Contact {
        id
        type
        number
        companyName
        companyNameExtension
        firstName
        lastName
      }
    }
  }
  depot{
    name
    label
  }
  location {
    id
    name
    label
  }
}
`;


export interface TourPlannerTasksQueryResponse {
  tasksForPlanning:Page<Task>;
}


